const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.alderadvisor.com';

const showResult = (form: HTMLFormElement, success: boolean, text: string): void => {
  let el = form.querySelector<HTMLParagraphElement>('.form-result');
  if (!el) {
    el = document.createElement('p');
    el.className = 'form-result';
    form.appendChild(el);
  }
  el.textContent = text;
  el.dataset.state = success ? 'success' : 'error';
};

const bindForm = (
  selector: string,
  endpoint: string,
  getPayload: (form: HTMLFormElement) => Record<string, unknown>
): void => {
  const form = document.querySelector<HTMLFormElement>(selector);
  if (!form) return;

  form.addEventListener('submit', (e: SubmitEvent) => {
    e.preventDefault();
    const btn = form.querySelector<HTMLButtonElement>('[type=submit]');
    if (!btn) return;

    btn.disabled = true;

    fetch(API_BASE + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(getPayload(form)),
    })
      .then((res) => {
        if (res.ok) {
          showResult(form, true, "Submitted successfully. We'll be in touch soon.");
          form.reset();
        } else {
          showResult(form, false, 'Something went wrong. Please try again.');
        }
      })
      .catch(() => {
        showResult(form, false, 'Network error. Please try again.');
      })
      .finally(() => {
        btn.disabled = false;
      });
  });
};

bindForm('.form-grid--contact', '/contact', (form: HTMLFormElement) => ({
  name: form.querySelector<HTMLInputElement>('[name=name]')?.value,
  email: form.querySelector<HTMLInputElement>('[name=email]')?.value,
  message: form.querySelector<HTMLTextAreaElement>('[name=message]')?.value,
}));

bindForm('.form-grid--demo', '/demo', (form: HTMLFormElement) => ({
  name: form.querySelector<HTMLInputElement>('[name=name]')?.value,
  email: form.querySelector<HTMLInputElement>('[name=email]')?.value,
  company: form.querySelector<HTMLInputElement>('[name=company]')?.value,
  phone: form.querySelector<HTMLInputElement>('[name=phone]')?.value || null,
  message: form.querySelector<HTMLTextAreaElement>('[name=message]')?.value || null,
}));
